import { CloseOutlined } from '@ant-design/icons';

import styles from './ItemButton.less';

interface ItemButtonProps {
  id: any;
  name: string;
  onDelete: (id: string) => void;
}

const ItemButton = ({ id, name, onDelete }: ItemButtonProps) => {
  return (
    <div className={styles.button} key={id}>
      {name}
      <span>
        <CloseOutlined
          style={{ color: '#E8E8E8' }}
          onClick={() => {
            onDelete(id);
          }}
        />
      </span>
    </div>
  );
};
export default ItemButton;
